
namespace TabAurous.ProductDevelopment {


    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class PDQuotationDialog extends _Ext.TransDialog<PDQuotationRow, any> {

        protected getFormKey() { return PDQuotationForm.formKey; }
        protected getIdProperty() { return PDQuotationRow.idProperty; }
        protected getLocalTextPrefix() { return PDQuotationRow.localTextPrefix; }
        protected getNameProperty() { return PDQuotationRow.nameProperty; }
        protected getService() { return PDQuotationService.baseUrl; }
        protected getDeletePermission() { return PDQuotationRow.deletePermission; }
        protected getInsertPermission() { return PDQuotationRow.insertPermission; }
        protected getUpdatePermission() { return PDQuotationRow.updatePermission; }
        protected useViewMode() { return true; }

        public form = new PDQuotationForm(this.idPrefix);

        TaxRegistred: number;
        TaxArray: any[];
        public Closing: boolean;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public ExchangeRate: number;
        public CurrencyId: number;
        public MarkUpPolicyId: number;
        public Coef: number;
        constructor() {
            super();
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 150;
            q.initItemEditor(this, this.form.ItemDetails, Config);
            //Make grid full width
            q.hideEditorLabel(this.form.ItemDetails);
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetWeight);
            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.AdditionalCharges);
            q.setTextRightAlign(this.form.GrossAmount);
            q.setTextRightAlign(this.form.Discount);
            q.setTextRightAlign(this.form.MarkUpPolicyId);
            q.setGridEditorHeight(this.form.ItemDetails, 300);

            //To Show Image on Right Top & Hide Categories
            q.SetCategorySixColumn(this.form.TransDate);
            q.SetCategoryFourColumn(this.form.BillNo);
            q.SetCategoryFullWidth(this.form.ItemDetails);
            q.SetSix12Column(this.form.FinancialYearId);
            q.SetCategoryTwoColumn(this.form.Pieces);
            q.SetCategoryFourColumn(this.form.NetAmount);
            q.SetCategoryFullWidth(this.form.Remark);
            q.HideCategoryLable(this.element);
            q.hideCaption(this.form.LedgerName);
            this.CurrencyId = Q.Authorization.userDefinition.CurrencyId;

            this.form.ItemDetails.slickGrid.setOptions({ forceFitColumns: true });


            // **** Get Party Details using PartyID **** 

            this.form.PartyId.changeSelect2(e => {
                this.form.MarkUpPolicyId.value = "";
                this.MarkUpPolicyId = 0;
                if (this.form.PartyId.value != "") {

                    let PartyDetails: OMS.CustomerRow;
                    OMS.CustomerService.Retrieve({
                        EntityId: parseInt(this.form.PartyId.value)
                    }, response => {
                        if (response.Entity != null)
                            PartyDetails = response.Entity
                    }, { async: false });
                    this.form.ItemDetails.PartyId = parseInt(this.form.PartyId.value);
                    this.form.LedgerName.value = PartyDetails.LedgerName;

                    this.TaxRegistred = parseInt(PartyDetails.TaxRegType);
                    if (PartyDetails.CurrencyId > 0) { 
                        this.form.CurrencyId.value = PartyDetails.CurrencyId.toString();
                        this.SetAmountFields(PartyDetails.CurrencyId);
                    }
                    else
                        this.form.CurrencyId.value = this.CurrencyId.toString();

                    this.form.GstVat.value = PartyDetails.GstVat;
                    let AddressDetails: OMS.AddressMasterRow;
                    OMS.AddressMasterService.GetAddress({
                        LedgerId: parseInt(this.form.PartyId.value)
                    },
                        response =>
                            AddressDetails = response.Entity,
                        { async: false }
                    );

                    if (AddressDetails != null) {
                        this.form.State.value = AddressDetails.StateName;
                        this.form.Country.value = AddressDetails.CountryName;
                        var city = AddressDetails.CityName;
                        let address = AddressDetails.Address1 + ", " + AddressDetails.Address2 + ", " + city + ", "
                            + this.form.State.value + ", " + this.form.Country.value + ", " + AddressDetails.Pincode;
                        this.form.Address1.value = address;

                    }
                    this.RateListId = PartyDetails.CostPricegroupId == null ? 0 : PartyDetails.CostPricegroupId;
                    this.LaborListId = PartyDetails.LbrPricegroupId == null ? 0 : PartyDetails.LbrPricegroupId;
                    this.StoneMarkup = PartyDetails.StnAddMkp == null ? 0 : PartyDetails.StnAddMkp;
                    this.StoneDiscount = PartyDetails.StnAddDisc == null ? 0 : PartyDetails.StnAddDisc;
                    this.LaborMarkup = PartyDetails.LbrAddMkp == null ? 0 : PartyDetails.LbrAddMkp;
                    this.LaborDiscount = PartyDetails.LbrAddDisc == null ? 0 : PartyDetails.LbrAddDisc;
                    this.Coef = PartyDetails.Coef == null ? 1 : PartyDetails.Coef;
                    var ExchangeDetails = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() == this.form.CurrencyId.value && x.FromDate <= this.form.TransDate.value && x.ToDate >= this.form.TransDate.value)[0];
                    this.form.ExchRate.value = ExchangeDetails.ExchRate;
                    this.ExchangeRate = this.form.ExchRate.value;
                    if (this.RateListId != null && this.RateListId > 0)
                        this.form.PriceListId.value = this.RateListId.toString();
                    //if (PartyDetails.MarkUpPolicyId != null && PartyDetails.MarkUpPolicyId > 0) {
                    //    this.form.MarkUpPolicyId.value = PartyDetails.MarkUpPolicyId.toString();
                    //    this.MarkUpPolicyId = PartyDetails.MarkUpPolicyId;
                    //} else {
                    //    OMS.CompanyService.Retrieve({ EntityId: this.form.CompanyId.value },
                    //        response => {
                    //            if (response.Entity != null) {
                    //                var company = response.Entity;
                    //                if (company.MarkUpPolicyId != null && company.MarkUpPolicyId > 0) {
                    //                    this.form.MarkUpPolicyId.value = company.MarkUpPolicyId.toString();
                    //                    this.MarkUpPolicyId = company.MarkUpPolicyId;
                    //                }
                    //            }
                    //        }, { async: false })
                    //}
                }
                else {
                    this.form.LedgerName.value = this.form.Address1.value = this.form.State.value = this.form.GstVat.value = this.form.Country.value = "";
                }
            });

            this.form.CurrencyId.changeSelect2(e => {
                var ExchangeDetails = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() == this.form.CurrencyId.value && x.FromDate <= this.form.TransDate.value && x.ToDate >= this.form.TransDate.value)[0];
                this.form.ExchRate.value = ExchangeDetails.ExchRate;
                this.ExchangeRate = ExchangeDetails.ExchRate;
                this.SetAmountFields(parseInt(this.form.CurrencyId.value))
            });
            this.form.PriceListId.changeSelect2(e => {
                this.RateListId = parseInt(this.form.PriceListId.value);
            });
            this.form.MarkUpPolicyId.changeSelect2(e => {

            });
            this.form.ExchRate.changeSelect2(e => {
                this.ExchangeRate = this.form.ExchRate.value;
            });
            (this.form.ItemDetails.view as any).onRowCountChanged.subscribe(() => {

                this.CalculateAmountandTax();
            })

            this.form.GrossAmount.addValidationRule(this.uniqueName, e => {
                //Validate that the knock off value is not less than or greater than total Amount
                if (this.form.ItemDetails.getItems().length == 0) {
                    Q.alert("There are no Items added in transaction. Can not save!!")
                    return "";
                }
            });

            this.validateForm();

        }

        public CalculateAmountandTax() {
            var Items = this.form.ItemDetails.getItems();
            var codearray = [];
            var amtarray = [];
            var ntamt = 0; var gramt = 0; var disc = 0; var pcs = 0; var nwt = 0; var wt = 0;

            //Items.forEach(function (x)
            for (var x of Items) {
                ntamt += x.NetAmount || 0;
                gramt += x.GrossAmount || 0;
                disc += x.Discount || 0;
                pcs += x.Pieces || 0;
                wt += x.Weight || 0;
                nwt += x.NetWeight || 0;

                if (x.HSN != null || x.HSN != "NA") {
                    var temp = false;
                    for (let i = 0; i < codearray.length; i++) {
                        if (codearray[i] == x.HSN) {
                            amtarray[i] += x.GrossAmount || 0;
                            temp = true;
                        }
                    }

                    if (!temp) {
                        codearray.push(x.HSN);
                        amtarray.push(x.GrossAmount);
                    }
                }
            };

            this.form.NetAmount.value = gramt;
            this.form.Discount.value = disc;

            var TaxAmount = 0;

            var TaxApplicable = OMS.VoucherMasterRow.getLookup().items.filter(x => x.VoucherTypeId == this.form.VoucherTypeId.value)[0].IsTaxApplicable;

            if (TaxApplicable) {

                this.form.GrossAmount.value = gramt + TaxAmount;
                this.form.Pieces.value = pcs;
                this.form.Weight.value = wt;
                this.form.NetWeight.value = nwt;
            }
            else {
                this.form.GrossAmount.value = gramt;
                this.form.Pieces.value = pcs;
                this.form.Weight.value = wt;
                this.form.NetWeight.value = nwt;
            }

            this.form.CCGrossAmount.value = this.form.GrossAmount.value * this.ExchangeRate;
            this.form.CCNetAmount.value = this.form.NetAmount.value * this.ExchangeRate
        }


        protected onDialogOpen() {
            super.onDialogOpen();
            var fieldEditor: JQuery = this.form.PartyId.element.closest(".editor");
            fieldEditor.addClass("has-inplace-button");
            $(' <button type="button">...</button>')
                .addClass('inplace-button')
                .addClass('inplace-search edit')
                .attr('title', 'Search')
                .insertAfter(fieldEditor)
                .click((e) => { this.inplaceSearchClick(e) }
                );
            let ChangePriceList = q.ToBool(TabAurous.GetConfigValue(1036));  
            if (ChangePriceList) {
                q.showAndEnableField(this.form.PriceListId);
                q.showAndEnableField(this.form.MarkUpPolicyId);
            } else {
                q.hideField(this.form.PriceListId);
                q.hideField(this.form.MarkUpPolicyId);
            }
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();
            if (this.form.CompanyId.value != 0 || this.form.FinancialYearId.value != 0 && this.isNew) {
                this.form.CompanyId.value = Q.Authorization.userDefinition.CompanyId;
                this.form.FinancialYearId.value = Q.Authorization.userDefinition.FinancialYearId;
                this.form.CurrencyId.value = Q.Authorization.userDefinition.CurrencyId.toString();
                var ExchangeDetails = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() == this.form.CurrencyId.value && x.FromDate <= this.form.TransDate.value && x.ToDate >= this.form.TransDate.value)[0];
                this.form.ExchRate.value = ExchangeDetails.ExchRate;
            }
            if (!Q.isEmptyOrNull(this.form.PartyId.value)) {
                this.SetAmountFields(parseInt(this.form.CurrencyId.value));
                q.showAndDisableField(this.form.PartyId);
                q.showAndDisableField(this.form.CurrencyId);
                q.showAndDisableField(this.form.ExchRate);
                let PartyDetails: OMS.CustomerRow;
                OMS.CustomerService.Retrieve({
                    EntityId: parseInt(this.form.PartyId.value)
                }, response => {
                    PartyDetails = response.Entity
                }, { async: false });
                this.form.ItemDetails.PartyId = parseInt(this.form.PartyId.value);
                this.form.LedgerName.value = PartyDetails.LedgerName;
                this.TaxRegistred = parseInt(PartyDetails.TaxRegType);
                this.form.GstVat.value = PartyDetails.GstVat;

                let AddressDetails: OMS.AddressMasterRow;
                OMS.AddressMasterService.GetAddress({
                    LedgerId: parseInt(this.form.PartyId.value)
                },
                    response =>
                        AddressDetails = response.Entity,
                    { async: false }
                );

                if (AddressDetails != null) {
                    this.form.State.value = AddressDetails.StateName;
                    this.form.Country.value = AddressDetails.CountryName;
                    var city = AddressDetails.CityName;
                    let address = AddressDetails.Address1 + ", " + AddressDetails.Address2 + ", " + city + ", "
                        + this.form.State.value + ", " + this.form.Country.value + ", " + AddressDetails.Pincode;
                    this.form.Address1.value = address;

                }

                let ChangePriceList = q.ToBool(TabAurous.GetConfigValue(1036)); 
                if (ChangePriceList) {
                    this.RateListId = parseInt(this.form.PriceListId.value);
                } else {
                    this.RateListId = PartyDetails.CostPricegroupId == null ? 0 : PartyDetails.CostPricegroupId;
                }


                this.LaborListId = PartyDetails.LbrPricegroupId == null ? 0 : PartyDetails.LbrPricegroupId;
                this.StoneMarkup = PartyDetails.StnAddMkp == null ? 0 : PartyDetails.StnAddMkp;
                this.StoneDiscount = PartyDetails.StnAddDisc == null ? 0 : PartyDetails.StnAddDisc;
                this.LaborMarkup = PartyDetails.LbrAddMkp == null ? 0 : PartyDetails.LbrAddMkp;
                this.LaborDiscount = PartyDetails.LbrAddDisc == null ? 0 : PartyDetails.LbrAddDisc;
                this.ExchangeRate = this.form.ExchRate.value;
                this.Coef = PartyDetails.Coef;

            }
        }

        protected inplaceSearchClick(e: any): void {
            var T = this.isViewMode();

            if (!this.isViewMode()) {
                if (this.form.ItemDetails.getItems().length == 0) {
                    var grid = OMS.CustomerGrid;
                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: false, title: "Select Supplier"
                    });

                    pickerDialog.onSuccess = (selectedItems: OMS.CustomerRow[]) => {

                        if (selectedItems.length > 0) {
                            this.form.MarkUpPolicyId.value = "";
                            this.MarkUpPolicyId = 0;
                            this.form.PartyId.value = selectedItems[0].LedgerId.toString();
                            this.form.LedgerName.value = selectedItems[0].LedgerName;
                            this.Coef = selectedItems[0].Coef;
                            this.form.ItemDetails.PartyId = parseInt(this.form.PartyId.value);
                            this.form.LedgerName.value = selectedItems[0].LedgerName;

                            this.RateListId = selectedItems[0].CostPricegroupId == null ? 3 : selectedItems[0].CostPricegroupId;
                            this.StoneMarkup = selectedItems[0].StnAddMkp == null ? 0 : selectedItems[0].StnAddMkp;
                            this.LaborMarkup = selectedItems[0].LbrAddMkp == null ? 0 : selectedItems[0].LbrAddMkp;
                            this.LaborListId = selectedItems[0].LbrPricegroupId == null ? 0 : selectedItems[0].LbrPricegroupId;
                            this.StoneDiscount = selectedItems[0].StnAddDisc == null ? 0 : selectedItems[0].StnAddDisc;
                            this.LaborDiscount = selectedItems[0].LbrAddDisc == null ? 0 : selectedItems[0].LbrAddDisc;
                            if (this.RateListId != null && this.RateListId > 0)
                                this.form.PriceListId.value = this.RateListId.toString();

                            if (selectedItems[0].CurrencyId > 0) {
                                this.form.CurrencyId.value = selectedItems[0].CurrencyId.toString();
                                this.SetAmountFields(selectedItems[0].CurrencyId);
                            }
                            else
                                this.form.CurrencyId.value = selectedItems[0].CurrencyId.toString();

                            var ExchangeDetails = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() == this.form.CurrencyId.value && x.FromDate <= this.form.TransDate.value && x.ToDate >= this.form.TransDate.value)[0];
                            this.ExchangeRate = this.form.ExchRate.value = ExchangeDetails.ExchRate;
                            this.TaxRegistred = parseInt(selectedItems[0].TaxRegType);

                            this.form.GstVat.value = selectedItems[0].GstVat;
                            let AddressDetails: OMS.AddressMasterRow;
                            OMS.AddressMasterService.GetAddress({
                                LedgerId: parseInt(this.form.PartyId.value)
                            },
                                response =>
                                    AddressDetails = response.Entity,
                                { async: false }
                            );

                            if (AddressDetails != null) {
                                this.form.State.value = AddressDetails.StateName;
                                this.form.Country.value = AddressDetails.CountryName;
                                var city = AddressDetails.CityName;
                                let address = AddressDetails.Address1 + ", " + AddressDetails.Address2 + ", " + city + ", "
                                    + this.form.State.value + ", " + this.form.Country.value + ", " + AddressDetails.Pincode;
                                this.form.Address1.value = address;

                            }
                            if (selectedItems[0].MarkUpPolicyId != null && selectedItems[0].MarkUpPolicyId > 0) {
                                this.form.MarkUpPolicyId.value = selectedItems[0].MarkUpPolicyId.toString();
                                this.MarkUpPolicyId = selectedItems[0].MarkUpPolicyId;
                            } else {
                                OMS.CompanyService.Retrieve({ EntityId: this.form.CompanyId.value },
                                    response => {
                                        if (response.Entity != null) {
                                            var company = response.Entity;
                                            if (company.MarkUpPolicyId != null && company.MarkUpPolicyId > 0) {
                                                this.form.MarkUpPolicyId.value = company.MarkUpPolicyId.toString();
                                                this.MarkUpPolicyId = company.MarkUpPolicyId;
                                            }
                                        }
                                    }, { async: false })
                            }
                        }
                    }
                    pickerDialog.dialogOpen();
                }
                else
                    q.Alert("Not Allowed", "Party can not be changed while items are added", 2000, false);
            }
            else {
                q.Alert("View Mode", "Can not make changes in view mode", 2000, false);
            }
        }

        SetAmountFields(value: number) {
            if (value != this.CurrencyId) {
                var CC = OMS.CurrencyMasterRow.getLookup().itemById[Q.Authorization.userDefinition.CurrencyId].CurrencyName;
                var FC = OMS.CurrencyMasterRow.getLookup().itemById[this.form.CurrencyId.value].CurrencyName;

                q.showAndDisableField(this.form.CCGrossAmount);
                q.showAndDisableField(this.form.CCNetAmount);
                q.setEditorLabel(this.form.GrossAmount, 'Total (' + FC + ')');
                q.setEditorLabel(this.form.NetAmount, 'Amount (' + FC + ')');
                q.setEditorLabel(this.form.CCGrossAmount, 'Total (' + CC + ')');
                q.setEditorLabel(this.form.CCNetAmount, 'Amount (' + CC + ')');
            }
            else {

                q.hideField(this.form.CCGrossAmount);
                q.hideField(this.form.CCNetAmount);
                q.setEditorLabel(this.form.GrossAmount, 'Total');
                q.setEditorLabel(this.form.NetAmount, 'Amount');

            }

        }


        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();
 
            //Submit Button
            btns.push({
                title: 'Submit',
                cssClass: 'export-Submit-button',
                icon: 'fa fa-upload',
                onClick: () => {
                    if (this.validateSubmit())
                        PDQuotationService.SubmitQuotation({ TransId: parseInt(this.form.TransId.value), VoucherNo: this.form.VoucherNo.value },
                            response => {
                                if (response.EntityId == this.form.TransId.value) {
                                    q.success('', 'Quotation Submitted', 2999, true);
                                    this.dialogClose();

                                }

                            }, { async: true })
                }
            });

            //btns.push({
            //    title: 'Submit New',
            //    cssClass: 'export-Submit-button',
            //    icon: 'fa fa-upload',
            //    onClick: () => {
            //        PDQuotationService.SubmitQuotation({
            //            TransId: parseInt(this.form.TransId.value)
            //        },
            //            response => {
            //                if (response.EntityId == this.form.TransId.value) {
            //                    q.success('', 'Quotation Submitted', 2999, true);
            //                    this.dialogClose();

            //                }

            //            }, { async: false })
            //    }
            //});


            //Approve Button
            btns.push({
                title: 'Approve',
                cssClass: 'export-Approve-button',
                icon: 'fa fa-check',
                onClick: () => {
                    PDQuotationService.ApproveQuotation({
                        TransId: parseInt(this.form.TransId.value)
                    },
                        response => {
                            if (response.EntityId == this.form.TransId.value) {
                                q.success('', 'Quotation Approved', 2999, true);
                                this.dialogClose();
                            }

                        }, { async: false })
                }
            });

            //Export PDF Button
            btns.push({
                title: 'Spec Sheet',
                cssClass: 'export-pdf-button',
                icon: 'fa fa-print text-blue',
                onClick: () => {
                    Q.postToService({
                        service: PDQuotationService.baseUrl + '/ExportSpecsSheet',
                        request: {
                            TransId: this.entityId,
                        }, 
                        target: '_blank'
                    }); 
                }
            });
            btns.push({
                title: 'Estimate',
                cssClass: 'export-pdf-button',
                icon: 'fa fa-print text-blue',
                onClick: () => {
                    Q.postToService({
                        service: PDQuotationService.baseUrl + '/ExportQuotation',
                        request: {
                            TransId: this.entityId, PrintSpecSheet: false
                        },
                        target: '_blank'
                    });
                }
            });
             

            return btns;
        } 

        validateBeforeSave() {
            var Isvalid = super.validateBeforeSave();
            if (this.form.ItemDetails.getItems().length == 0) {
                Q.alert("No Items added, At least add one entry. Can not Save! ")
                Isvalid = false;
            }

            return Isvalid;

        }

        validateSubmit() {
            let IsValid = true;
            for (var i = 0; i < this.form.ItemDetails.getItems().length; i++) {
                let items = this.form.ItemDetails.getItems();
                items[i].BOMDetails.forEach(function (x) {
                    if (x.ProductId == null || x.ProductId.toString() == "")
                        x.ProductId = items[i].ProductId;

                    if (x.BomRate == null || x.BomRate <= 0 || x.BomAmount == null || x.BomAmount <= 0) {
                        var msg = q.text('Message.Component.RateNotDefined', 'Rate not Defined for Component ' + items[i].ProductCode + ', Can not Save!');
                        Q.alert(msg)
                        IsValid = false;
                    }
                })

                if (items[i].LaborDetails.length > 0) {
                    items[i].LaborDetails.forEach(function (x) {
                        if (x.LabourRate == null || x.LabourRate <= 0 || x.LabourAmount == null || x.LabourAmount <= 0) {
                            Q.alert("Rate not Defined for labor, Can not Save!")
                            IsValid= false;
                        }
                    })
                }
            }

            return IsValid
        }         

    }
}